import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SendContractPaymentInvoiceMutation } from "../graphql/mutations";
import type {
  SendContractPaymentInvoiceMutationType,
  SendContractPaymentInvoiceMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useSendContractPaymentInvoiceMutation = (
  options?: MutationHookOptions<
    SendContractPaymentInvoiceMutationType,
    SendContractPaymentInvoiceMutationVariablesType
  >
) => {
  return useMutation<
    SendContractPaymentInvoiceMutationType,
    SendContractPaymentInvoiceMutationVariablesType
  >(SendContractPaymentInvoiceMutation, options);
};
